import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store';
import Vuex from 'vuex';
import DatetimePicker from 'vuetify-datetime-picker';
import { ValidationProvider, ValidationObserver, extend, setInteractionMode  } from 'vee-validate';
import { required, max, email, integer, regex } from 'vee-validate/dist/rules';

Vue.config.productionTip = false;
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

setInteractionMode('aggressive');

extend('required', {
  ...required,
  message: 'Required Field'
});

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
})

extend('email', {
  ...email,
  message: 'Email must be valid',
});

extend('integer', {
  ...integer,
  message: 'Must be rounded to a whole number, like: 4000',
});

extend('regex', {
  ...regex,
  message: 'Must follow pattern: 703-228-5000',
});
new Vue({
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.use(DatetimePicker);
Vue.use(Vuex);